import { useCallback, useEffect, useState } from 'react';
import { useAuthStore } from '@/stores';
import * as api from '@/lib/api';
import { getAppMeta, setAppMeta } from '@/lib/db';

export interface DashboardData {
  recentSales: any;
  bookingsActivity: any;
  todaysBookings: any;
  topServices: any;
}

export function useDashboard() {
  const workspaceId = useAuthStore((s) => s.workspaceId);
  const [data, setData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDashboard = useCallback(async () => {
    if (!workspaceId) return;
    setLoading(true);
    setError(null);

    let hasCachedData = false;
    try {
      const cached = await getAppMeta<DashboardData>(`dashboard_${workspaceId}`);
      if (cached) {
        setData(cached);
        hasCachedData = true;
      }

      const res = await api.getDashboard(workspaceId);
      if (res.success && res.data) {
        await setAppMeta(`dashboard_${workspaceId}`, res.data);
        setData(res.data);
      }
    } catch (err: any) {
      if (!hasCachedData) {
        setError(err?.message || 'Error al cargar métricas');
      }
    } finally {
      setLoading(false);
    }
  }, [workspaceId]);

  useEffect(() => {
    // oxlint-disable-next-line react/set-state-in-effect
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    data,
    loading,
    error,
    refresh: fetchDashboard,
  };
}

